// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"Banner_bannerWrapper__1jkLG","bannerText":"Banner_bannerText__2R672"};